import { CORP_CLAIMS } from 'src/components/AuthProvider/AuthProvider';
import { CorpUIResponse } from 'src/types/Corp';
import { DataDogRumCorpContext } from './datadogRumApi';

export const transformCorpResponse = (
  corp: CorpUIResponse,
  role: CORP_CLAIMS
): DataDogRumCorpContext => ({
  corpId: corp.id,
  corpName: corp.name,
  corpUserRole: role.toUpperCase(),
  corpType: corp.signUpType,
});
